<template>
  <div class="order-converted-info">
    <div class="order-detail-item order-detail-status">
      <div class="order-detail-audit-status">
        <div class="color-black bold">
          订单审核状态：{{ orderDetail.refund_info.status | orderStatus }}
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        学员信息
      </div>
      <div class="order-detail-student">
        <div class="order-detail-people-name">
          <span
            class="order-detail-student-name"
          >学员姓名： {{ orderDetail.child_info.child_name }}</span>
          <span>就读小学：{{ orderDetail.child_info.school_name }}</span>
          <span>就读年级：{{ orderDetail.child_info.grade_name }}</span>
        </div>
        <div class="order-detail-people-name">
          <span
            class="order-detail-student-name"
          >家长姓名：{{ orderDetail.child_info.parent_name }}</span>
          <span>家长电话：{{ orderDetail.child_info.mobile }}</span>
        </div>
      </div>
    </div>
    <!-- 退款 -->
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        退款信息
      </div>
      <div class="order-detail-package">
        <div class="color-danger">
          应退金额：¥{{ orderDetail.refund_info.refundable_amount / 100 }}
        </div>
        <div>
          内转金额：¥{{ orderDetail.refund_info.adversion_amount / 100 }}
        </div>
        <div class="color-danger">
          实际退费：¥{{ orderDetail.refund_info.amount / 100 }}
        </div>
        <div v-if="orderDetail.refund_info.extra_supply.refund_account_name">
          <div>退款方式：{{ orderDetail.refund_info.payment | payType }}</div>
          <div>
            退款账户：{{
              orderDetail.refund_info.extra_supply.refund_account_name
            }}
          </div>
          <div>
            退款账户卡号：{{
              orderDetail.refund_info.extra_supply.refund_account
            }}
          </div>
          <div v-if="orderDetail.refund_info.summary">
            财务退款单号：{{ orderDetail.refund_info.summary }}
          </div>
        </div>
      </div>
      <div class="order-detail-package">
        <div class="color-black bold">退款套餐</div>
        <div
          v-for="(item, index) in orderDetail.refund_info.extra"
          :key="index"
          class="order-refund-list"
        >
          <div class="order-detail-people-name">
            <span>签约单号：{{ item.billing_id }}</span>
            <span>订单金额：¥{{ item.amount / 100 }}</span>
          </div>
          <table class="special-table">
            <thead>
              <tr>
                <th>类型</th>
                <th>订单课时（天）</th>
                <th>已上课时（天）</th>
                <th>退费课时（天）</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ item.value_info.key_name }}</td>
                <td>{{ item.value_info.days }}</td>
                <td>{{ item.value_info.consume_days }}</td>
                <td>
                  {{ item.value_info.days - item.value_info.consume_days }}
                </td>
              </tr>
              <tr>
                <td colspan="4" style="text-align:left;padding-left:30px">
                  <span
                    v-if="item.value_info.consume_days"
                  >退款金额：￥{{
                    (item.value_info.price_refund / 100) *
                      (item.value_info.days - item.value_info.consume_days)
                  }}</span>
                  <span v-else>{{ item.value_info.total_refund / 100 }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="4" style="text-align:left;padding-left:30px">
                  <span>财务退款单号：{{
                    item.billing_info.selling_billing_token
                  }}</span>
                </td>
              </tr>
              <tr v-if="item.value_info.invoice_status == '1'">
                <td colspan="4" style="text-align:left;padding-left:30px">
                  <span>
                    发票信息：{{
                      item.value_info.invoice == "1" ? "已归还" : "未归还"
                    }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        内转订单信息
      </div>
      <div
        v-if="orderDetail.adversion_info.adversion_amount"
        class="order-detail-package"
      >
        <div class="color-danger">
          实际支付：{{ orderDetail.adversion_info.adversion_amount / 100 }}
        </div>
        <div v-if="orderDetail.adversion_info.payment">
          支付方式：{{ orderDetail.adversion_info.payment }}
        </div>
        <!-- <div>支付时间：2019-07-04 17:37:41</div>  -->
      </div>
      <el-table :data="orderDetail.adversion_info.adversion_list">
        <el-table-column
          prop="selling_billing_yuid"
          label="签约单号"
        />
        <el-table-column
          prop="selling_item_display"
          label="套餐名称"
        />
        <el-table-column prop="selling_item_pric" label="套餐金额">
          <template slot-scope="scope">
            <div class="color-black">
              {{ scope.row.selling_item_price / 100 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="selling_billing_num"
          label="数量"
        />
        <el-table-column prop="selling_billing_price" label="实付金额">
          <template slot-scope="scope">
            <div class="color-black">
              {{ scope.row.selling_billing_price / 100 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="合同">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="orderImg(scope.row)"
            >电子合同</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        责任人信息
      </div>
      <div class="order-detail-sales">
        <div class="order-detail-people-name">
          <span>提交人：{{ orderDetail.refund_info.editor_name }}</span>
          <span
            v-if="orderDetail.refund_info.extra_supply.person_liable"
          >责任人：{{
            orderDetail.refund_info.extra_supply.person_liable
              .person_liable_name
          }}</span>
          <span>班主任：{{ orderDetail.refund_info.headmaster_name }}</span>
        </div>
      </div>
    </div>
    <!-- 内转审核显示 -->
    <div v-if="type == 'convertedAudit'" class="order-audit-btn">
      <el-row
        v-if="orderDetail.refund_info.extra_supply.refund_account_name"
        type="flex"
        justify="end"
      >
        <el-input
          v-model="token"
          clearable
          placeholder="请输入财务流水单号"
        />
        <el-button
          type="primary"
          @click="adversionAuditSuccess('1')"
        >确认打款</el-button>
      </el-row>
      <el-row v-else type="flex" justify="end">
        <el-button
          type="primary"
          @click="adversionAuditSuccess('2')"
        >审核成功</el-button>
      </el-row>
      <el-row type="flex" justify="end">
        <el-button type="info" @click="adversionAuditFail">审核失败</el-button>
      </el-row>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible5"
      title="合同预览"
      class="refund-order-img"
      append-to-body
    >
      <div class="agreement_picture">
        <div class="pdf">
          <iframe
            :src="src"
            frameborder="0"
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'OrderConvertedInfo',
  filters: {
    orderStatus(value) {
      if (value == '2' || value == '6') {
        return '待财务审核'
      } else if (value == '3') {
        return '审核失败'
      } else if (value == '4') {
        return '财务打款成功'
      }
    },
    payType(val) {
      if (val == 'alipay') {
        return '支付宝'
      } else if (val == 'lkl') {
        return 'POS支付'
      } else if (val == 'turn') {
        return '直接转账'
      } else if (val == 'cash') {
        return '现金支付'
      } else if (val == 'bank') {
        return '银行卡'
      }
    }
  },
  props: {
    orderDetail: Object,
    type: String
  },
  data() {
    return {
      src: '',
      dialogVisible5: false,
      token: ''
    }
  },
  methods: {
    orderImg(row) {
      this.dialogVisible5 = true
      this.src = row.extra.order_img
    },
    adversionAuditSuccess(type) {
      if (type == '1' && !this.token) {
        this.$message({
          type: 'info',
          message: '请输入财务流水单号'
        })
        return
      }
      const obj = {
        id: this.orderDetail.refund_info.id,
        token: this.token
      }
      this.$http.adversionAuditSuccess(obj).then(res => {
        if (res.code == 200) {
          this.$emit('updateOrderList')
        }
      })
    },
    adversionAuditFail() {
      this.$http
        .adversionAuditFail({ id: this.orderDetail.refund_info.id })
        .then(res => {
          if (res.code == 200) {
            this.$emit('updateOrderList')
          }
        })
    }
  }
}
</script>

<style lang="scss">
.order-detail-dialog .el-dialog__body {
  height: 700px;
  padding: 20px 30px;
  overflow: auto;
  .order-converted-info {
    line-height: 24px;
    .order-detail-item {
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #f5f5f5;
    }
    .order-detail-status {
      padding: 15px 20px;
      background-color: #f5f5f5;
    }
    .order-detail-item-title {
      margin-bottom: 15px;
    }
    .order-detail-people-name span {
      margin-right: 30px;
    }
    .order-detail-student-name {
      width: 160px;
    }
    .el-table {
      margin-top: 10px;
    }
    .el-table tr th {
      height: 34px !important;
      background: #fff !important;
      color: #333;
    }
    .el-table td,
    .el-table th {
      padding: 4px;
      border: 1px solid #f5f5f5;
    }
  }
  .order-audit-btn {
    .el-row {
      margin-bottom: 10px;
    }
    .el-input {
      margin-right: 20px;
    }
  }
  .special-table {
    width: 100%;
    margin: 10px 0;
    border: 1px solid #f5f5f5;
    tr,
    th,
    td {
      text-align: center;
      padding: 10px 0;
      border: 1px solid #f5f5f5;
    }
  }
}
.refund-order-img .el-dialog {
  width: 50% !important;
  height: 95% !important;
  background: #fff !important;
  z-index: 9999;
  .el-dialog__body {
    height: 90%;
  }
  .agreement_picture,
  .pdf {
    height: 100%;
  }
}
</style>
